import { IKnmListFilterExtra } from '../interfaces/IKnmListFilterExtra';

export const exclusionErpAdditionalFields: (keyof IKnmListFilterExtra)[] = ['approveRequiredType'];
